import { QContentActivityLogList } from '@exam-management/qcontent-activity-log-list';
import { useParams } from '@exam-management/router';
import { Box } from '@shared/components';

export default function ItemSetActivityLogPage() {
  const { questionId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/activity-log',
  );
  return (
    <Box sx={{ p: (theme) => theme.spacing(6) }}>
      <QContentActivityLogList questionGroupId={questionId} />
    </Box>
  );
}
